import { ModalWrapper } from 'src/components/modal-wrapper'

import { useStyles } from './../../styles'
import { LoginProvidersModalInner } from './login-providers-modal-inner.component'
import { IUserProviderResponse } from 'src/types'

interface IProps {
  providers: void | IUserProviderResponse[] | undefined
  isLoading: boolean
  open: boolean
  onClose: () => void
  showConnectToXButton: boolean
}

const LoginProvidersModal = ({
  open,
  onClose,
  providers,
  isLoading,
  showConnectToXButton,
}: IProps) => {
  const classes = useStyles()
  return (
    <ModalWrapper open={open} onClose={onClose} className={classes.loginProvidersModalWrapper}>
      <LoginProvidersModalInner
        providers={providers}
        isLoading={isLoading}
        showConnectToXButton={showConnectToXButton}
      />
    </ModalWrapper>
  )
}

export { LoginProvidersModal }
